import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-statistiche-emissioni',
	templateUrl: './statistiche-emissioni.component.html',
	styleUrls: ['./statistiche-emissioni.component.css']
})
export class StatisticheEmissioniComponent implements OnInit {

	emissioniSync: Subscription;
	emissioni : any[];
	emissioneSelected : string = 'select';

	tipiNotificaSync: Subscription;
	tipiNotifica: any[] = [];

	headerFields = [
		{
			label: "Stato",
			code: "stato",
			class: "tab-cell-25"
		},
		{
			label: "n.prat",
			code: "n_prat",
			class: "tab-cell-25"
		},
		{
			label: "Pagato",
			code: "pagato",
			class: "tab-cell-25"
		},
		{
			label: "Non Scadute",
			code: "non_scadute",
			class: "tab-cell-25"
		},
		{
			label: "Scadute",
			code: "scadute",
			class: "tab-cell-25"
		}
	];

	rowFields : any[] = [
		{
			"stato" : "",
			"n_prat" : "",
			"pagato" : "",
			"non_scadute" : "",
			"scadute" : ""
		},
		{
			"stato" : "",
			"n_prat" : "",
			"pagato" : "",
			"non_scadute" : "",
			"scadute" : ""
		},
		{
			"stato" : "",
			"n_prat" : "",
			"pagato" : "",
			"non_scadute" : "",
			"scadute" : ""
		}
	]

	constructor(
		private dataService : DataService
		) { }

	ngOnInit() {
		this.emissioniSync = this.dataService.emissioni$.subscribe(
			emissioni => {
				this.emissioneSelected = 'select';
				if (emissioni) {
					this.emissioni = emissioni;
				}
				else {
					this.emissioni = [];
				}
			});
		this.tipiNotificaSync = this.dataService.tipiNotifica$.subscribe(
			tipiNotifica => {
				this.tipiNotifica = tipiNotifica;
			});
	}

}
